<template>
	<v-container grid-list-xl>
		<v-layout row wrap>
				<br />
				<v-flex lg6>
					<label class="blackLabel">CLIENT DETAILS</label>
				</v-flex>
				<v-flex lg6>
					<label class="blackLabel">PROJECT MODULE</label>
				</v-flex>
				<v-flex lg6>
					<label class="blackLabel">Client</label>
					<v-select :items="setupClients" label="Client" class="dropdown" v-model="setupClient" item-text="client_name" solo single-line></v-select>
				</v-flex>
				<v-flex lg6>
					<label class="blackLabel">Initialize Project Module</label>
                    <v-switch label="Create an instance of Project Module for the MyOrder instance" v-model="setupProjectModule"></v-switch>
				</v-flex>
				<v-flex lg12>
					<label class="blackLabel">SUPER USER DETAILS</label>
				</v-flex>
				<v-flex xs6>
					<label class="blackLabel">Name</label>
					<v-text-field label="Name" v-model="setupName" solo></v-text-field>
				</v-flex>
				<v-flex xs6>
					<label class="blackLabel">Surname</label>
					<v-text-field label="Surname" v-model="setupSurname" solo></v-text-field>
				</v-flex>
				<v-flex xs4>
					<label class="blackLabel">Email</label>
					<v-text-field label="Email" v-model="setupEmail" solo></v-text-field>
				</v-flex>
				<v-flex xs4>
					<label class="blackLabel">Password</label>
					<v-text-field label="Password" type="password" v-model="setupPassword" solo></v-text-field>
				</v-flex>
				<v-flex xs4>
					<label class="blackLabel">Confirm Password</label>
					<v-text-field label="Password Confirm" type="password" v-model="setupPasswordConfirm" solo></v-text-field>
				</v-flex>
			<div class="pl-4 pr-4 pb-4 buttonHolder">
				<div style="float: right">			
					<v-btn color="success" class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
					<!--<v-progress-circular indeterminate :width="3" :size="20" color="grey" class="pt-3 loginLoader"></v-progress-circular>-->
					<v-btn color="success" :disabled="fncCheckDisable()" class="text-xs-right" @click.stop="fncSetup">Create</v-btn>
				</div>	
			</div>
			<v-flex lg12 class="requiredMessage">
				<small><strong>&nbsp;</strong></small>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>

	import { mapGetters } from 'vuex'; 
	
	export default {
	  name: 'Settings',
	  data () {
			return {
				snack: true,
				hasEdited: false,
                setupClient: '',
				setupEmail: 'superuser@ndtec.co.za',
				setupName: 'Super',
				setupSurname: 'User',
				setupPassword: '',
				setupPasswordConfirm: '',
                setupProjectModule: false
			};
		},
		beforeMount() {
			this.$store.dispatch('fncGetClients');
		},
		methods: {
			fncHideModal () {
				this.$store.commit('hideModal');
			},
			fncSetup() {
				this.$store.dispatch({
					type: 'fncSetup',
					setupClient: this.setupClient,
					setupEmail: this.setupEmail,
					setupName: this.setupName,
					setupSurname: this.setupSurname,
					setupPassword: this.setupPassword,
                    setupProjectModule: this.setupProjectModule
				});
			},
			fncCheckDisable() {
				var isDisabled = false;
				if( ( this.setupClient == '' || this.setupEmail == '' || this.setupName == '' || this.setupSurname == '' || this.setupPassword == '' ) && ( this.setupPassword != this.setupPasswordConfirm ) ) {
					isDisabled = true;
				}
				return isDisabled;
			}
		},
		computed: {
		...mapGetters([			
			'objAuthorize',
			'setupClients'
		])
	},
	  }
</script>

<style scoped>
	@import './assets/css/shared.css'
</style>